<template>
  <div>
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <span v-on="on">
          <div class="title" style="margin-top:20px;">To-Do-Liste</div>
        </span>
      </template>
      <span>
        Spezielle Maßnahmen die diese TOM betreffen<br />
        und nicht einem Verfahren zuzuordnen sind.<br />
      </span>
    </v-tooltip>
    <v-list>
      <!-- list of measureSetMeasures -->
      <measure-list-item
        v-for="(measure, index) in measures"
        v-bind:item="measure"
        v-bind:index="index"
        :oldItem="Object.assign({}, measure)"
        v-on:update-item="updateMeasure"
        v-on:delete-item="deleteMeasure"
        :key="measure.id"
      />
      <measure-list-new-item v-bind:newItem="newMeasure" v-on:create-item="createMeasure" />
    </v-list>
  </div>
</template>

<script>
import MeasureListItem from "./lib/MeasureListItem";
import MeasureListNewItem from "./lib/MeasureListNewItem";

import { createMeasureSetMeasure, updateMeasureSetMeasure, deleteMeasureSetMeasure } from "../graphql/mutations";

export default {
  components: {
    MeasureListItem,
    MeasureListNewItem,
  },
  name: "MSetMeasureListView",
  props: {
    companyId: String,
    measureSetId: String,
    measures: Array,
  },
  computed: {
    createMeasureMutation() {
      return this.$Amplify.graphqlOperation(createMeasureSetMeasure, { input: this.newMeasure });
    },
    updateMeasureMutation() {
      return this.$Amplify.graphqlOperation(updateMeasureSetMeasure, { input: this.currentMeasure });
    },
    deleteMeasureMutation() {
      return this.$Amplify.graphqlOperation(deleteMeasureSetMeasure, { input: this.currentMeasure });
    },
  },
  mounted() {
    this.initNewMeasure(this.$route.params.msid);
  },
  methods: {
    initNewMeasure(msid) {
      this.newMeasure = {
        label: "",
        status: "OPEN",
        measureSetMeasureMeasureSetId: msid,
      };
    },
    createMeasure() {
      this.$eventHub.emit("sync-status-syncing");
      this.$Amplify.API.graphql(this.createMeasureMutation)
        .then((response) => {
          this.onMeasureCreated(response);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Einzelmaßnahme",
            entity_label: response.data.createMeasureSetMeasure.label,
            sync_type: "create",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Einzelmaßnahme",
            entity_label: this.newMeasure.label,
            sync_type: "create",
            error: err.errors[0].message,
          });
        });
    },
    updateMeasure(oldMeasure, measureSetMeasure, index) {
      this.$eventHub.emit("sync-status-syncing");
      this.currentMeasure = measureSetMeasure;
      delete this.currentMeasure.measureSet;
      this.$Amplify.API.graphql(this.updateMeasureMutation)
        .then((response) => {
          this.$recordUpdate(this.companyId, "MEASURESETMEASURE", oldMeasure, this.currentMeasure, (res, err) => {
            res
              ? console.log("logged MEASURESETMEASURE update", res)
              : console.error("error logging MEASURESETMEASURE update", err, e);
          });
          this.onMeasureUpdated(response, index);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Einzelmaßnahme",
            entity_label: measureSetMeasure.label,
            sync_type: "update",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Einzelmaßnahme",
            entity_label: measureSetMeasure.label,
            sync_type: "update",
            error: err.errors[0].message,
          });
        });
    },
    deleteMeasure(measureSetMeasure, index) {
      this.$eventHub.emit("sync-status-syncing");
      this.currentMeasure = { id: measureSetMeasure.id };
      this.$Amplify.API.graphql(this.deleteMeasureMutation)
        .then((response) => {
          measureSetMeasure.measureSetMeasureMeasureSetId = this.measureSetId;
          this.$recordDelete(this.companyId, "MEASURESETMEASURE", measureSetMeasure, (res, err) => {
            res
              ? console.log("logged MEASURESETMEASURE delete", res)
              : console.error("error logging MEASURESETMEASURE delete", err, e);
          });
          this.onMeasureDeleted(index);
          this.$eventHub.emit("sync-status-success", {
            entity_type: "Einzelmaßnahme",
            entity_label: measureSetMeasure.label,
            sync_type: "delete",
          });
        })
        .catch((err) => {
          console.error(err);
          this.$eventHub.emit("sync-status-failure", {
            entity_type: "Einzelmaßnahme",
            entity_label: measureSetMeasure.label,
            sync_type: "delete",
            error: err.errors[0].message,
          });
        });
    },
    onMeasureCreated(resp) {
      this.newMeasure.id = resp.data.createMeasureSetMeasure.id;
      this.$recordCreate(this.companyId, "MEASURESETMEASURE", this.newMeasure, (res, err) => {
        res
          ? console.log("logged MEASURESETMEASURE create", res)
          : console.error("error logging MEASURESETMEASURE create", err, e);
      });
      this.$emit("measureCreated", this.newMeasure);
      this.initNewMeasure(this.$route.params.msid);
    },
    onMeasureUpdated(resp, index) {
      this.$emit("measureUpdated", this.currentMeasure, index);
      this.currentMeasure = null;
    },
    onMeasureDeleted(index) {
      this.$emit("measureDeleted", index);
    },
  },
  data: () => ({
    newMeasure: null,
    currentMeasure: null,
    oldMeasure: null,
  }),
};
</script>

<style scoped></style>
